import { getIndustriesState } from './industries.selectors';
import ListTrait from 'src/app/traits/list.trait';
import { SetDefaultData, UpdateField, FetchIndustriesRequest, DeleteIndustryRequest } from './industries.actions';
import { Router, ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { Map } from 'immutable';

@Component({
  selector: 'app-industries',
  templateUrl: './industries.component.html',
  styleUrls: ['./industries.component.css']
})
export class IndustriesComponent extends ListTrait implements OnInit {

  private state$: Subscription;
  private route$: Subscription;
  private shouldReload: boolean = false;
  public isLoading: boolean = false;
  public columns: object[] = [
    {
      prop: 'name',
      name: 'NAME',
      sortable: true
    },
    {
      prop: 'millRate',
      name: 'MILL_RATE'
    },
    {
      prop: 'penaltyPercentage',
      name: 'PENTALTY_%'
    },
    {
      prop: 'minTax',
      name: 'MINIMUM_TAX'
    },
    {
      width: '162px',
      name: '',
      template: 'actionsColumn'
    }
  ]

  constructor(private store: Store<any>, public router: Router, private route: ActivatedRoute) {
    super(router)
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store.pipe(select(getIndustriesState)).subscribe(state => {
      this.state = state;
      this.isLoading = state.get('isLoading');
      if (state.get('shouldReload') != this.shouldReload && state.get('shouldReload')) {
        this.runFilter();
      }
      this.shouldReload = state.get('shouldReload');
    });

    this.route$ = this.route.queryParams.subscribe(this.runFilter.bind(this));
  }


  ngOnDestroy() {
    this.state$.unsubscribe()
    this.route$.unsubscribe()
  }


  runFilter(queryParams: any = {}) {

    const { page, page_size } = this.state.get('queryParams').toJS();
    const params = { page, page_size, ...queryParams };

    this.store.dispatch<any>(
      new FetchIndustriesRequest({
        filter: { keyword: params.keyword },
        itemsPerPage: parseInt(params.page_size),
        page: parseInt(params.page) - 1,
        order: {
          sort: params.sort,
          by: params.order_by,
        }
      })
    );

    this.store.dispatch(
      new UpdateField('queryParams', params, 'list')
    );
  }

  deleteIndustry(id: number) {
    this.store.dispatch(
      new DeleteIndustryRequest(id)
    );

  }
}
